module.exports = __webpack_public_path__ + "img/film-estirable-automatic.c6b8255b.jpg";